import { queryClient } from "@/App";
import config from "@/config";
import { useLogto } from "@logto/react";
import { createFileRoute, redirect } from "@tanstack/react-router";

import type { LogtoUser } from "@/types/logtoUser";
import { logtoUserQueryKey } from "@/hooks/api/useLogtoUser";
import Button from "@/components/atoms/actions/Button";

const ByePage = () => {
  const { signOut } = useLogto();

  const logout = () => signOut(config.LOGTO_LOGOUT_URL);

  return (
    <div className="bg-white p-2">
      <div>You have been removed from the organization.</div>
      <Button onClick={logout} label={"Log out"} />
    </div>
  );
};

export const Route = createFileRoute("/_authenticated/bye")({
  component: ByePage,
  beforeLoad: () => {
    const user = queryClient.getQueryData<LogtoUser>(logtoUserQueryKey);
    if (!user?.custom_data?.suspended) throw redirect({ to: "/" });
  },
});
